import React, { useState } from 'react';
import { IconSpark, IconArrowLeft, IconArrowRight, IconTarget } from './icons';
import { logFlashcard, conceptsFromText } from './memoryLog';

/*
 * FlashcardDeck — a compact, self-contained flip-card deck rendered INLINE
 * inside a chat message, so flashcards are part of the one continuous
 * conversation (not a separate screen). Receives its cards as a prop.
 */
const RATINGS = [
  { key: 'again', label: 'Again', color: '#ef4444' },
  { key: 'hard', label: 'Hard', color: '#f59e0b' },
  { key: 'good', label: 'Good', color: '#10b981' },
  { key: 'easy', label: 'Easy', color: '#3b82f6' },
];

const FlashcardDeck = ({ cards = [], accent = '#a855f7' }) => {
  const [deck, setDeck] = useState(cards);
  const [index, setIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);

  const card = deck[index];
  if (!card) return null;
  const shortAnswer = card.answer.length <= 24;

  const prev = () => { setFlipped(false); setIndex((i) => Math.max(0, i - 1)); };
  const next = () => { setFlipped(false); setIndex((i) => Math.min(deck.length - 1, i + 1)); };
  const rate = (ratingKey) => {
    const cids = (card.concept_ids && card.concept_ids.length)
      ? card.concept_ids
      : conceptsFromText('flashcards', [card.topic || card.category]);
    logFlashcard(cids, ratingKey);
    setFlipped(false);
    setIndex((i) => (i + 1) % deck.length);
  };
  const shuffle = () => {
    const a = [...deck];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    setDeck(a); setIndex(0); setFlipped(false);
  };

  return (
    <div className="nano-deck">
      <div className="nano-flash-toolbar">
        <span className="nano-flash-count">{index + 1} / {deck.length}</span>
        <button className="nano-shuffle" onClick={shuffle} type="button"><IconSpark size={13} /> Shuffle</button>
      </div>

      <div className={`nano-card${flipped ? ' flipped' : ''}`} onClick={() => setFlipped((f) => !f)}>
        <div className="nano-card-inner">
          <div className="nano-card-face nano-card-front">
            <div className="nano-card-kicker" style={{ color: accent }}>{card.topic || 'Flashcard'}</div>
            <div className="nano-card-q">{card.question}</div>
            <div className="nano-card-hintline"><IconTarget size={12} /> Click to reveal answer</div>
          </div>
          <div className="nano-card-face nano-card-back">
            <div className="nano-card-kicker" style={{ color: accent }}>Answer</div>
            {shortAnswer
              ? <div className="nano-card-a-big">{card.answer}</div>
              : <div className="nano-card-a">{card.answer}</div>}
            {card.category && <div className="nano-card-badge">{card.category}</div>}
          </div>
        </div>
      </div>

      <div className="nano-flash-nav">
        <button className="nano-nav-btn" onClick={prev} disabled={index === 0} type="button"><IconArrowLeft size={16} /></button>
        {deck.length <= 12 && (
          <div className="nano-flash-dots">
            {deck.map((_, i) => <span key={i} className={`nano-dot${i === index ? ' on' : ''}`} />)}
          </div>
        )}
        <button className="nano-nav-btn" onClick={next} disabled={index === deck.length - 1} type="button"><IconArrowRight size={16} /></button>
      </div>

      {flipped && (
        <div className="nano-rate-row">
          {RATINGS.map((r) => (
            <button key={r.key} className={`nano-rate ${r.key}`} onClick={() => rate(r.key)} type="button">
              <span className="dot" style={{ background: r.color }} /> {r.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FlashcardDeck;
